export const INITIAL_PAGINATION_STATE = {
    current_page_num: 0,
    num_pages: 0,
    num_items: 0,
    start_index: 0,
    end_index: 0,
};
export const INITIAL_SIMPLE_PAGINATION_STATE = {
    current_page_num: 1,
    num_pages: 0,
    num_items: 0,
    start_index: 0,
    end_index: 0,
};
/**
 * This enum represents the options for controlling our pagination, e.g. on the custom securities list page.
 */
export var PaginationControls;
(function (PaginationControls) {
    PaginationControls["FIRST"] = "first";
    PaginationControls["NEXT"] = "next";
    PaginationControls["PREV"] = "prev";
    PaginationControls["LAST"] = "last";
})(PaginationControls || (PaginationControls = {}));
